import {DataObjectId, User, UserAccount, UserStatus} from 'yougile-model'
import {Accounts} from '../../client/accounts'
import {Sync} from '../../client/sync'
import {UserAvatarUtils} from '../user-avatar-utils'

export interface UserProxy {
  readonly userId: DataObjectId
  readonly userImage: string
  readonly userInfo: string
  readonly userName: string
  readonly userShortName: string
  readonly userBackgroundColor: string
  readonly userStatus: UserStatus
  readonly userIsInDoNotDisturbMode: boolean
  readonly userIsAdmin: boolean
  readonly userEmail: string
  readonly userRole?: string
  deleted: boolean
}

export const UserProxy = {
  create: (user?: User, userAccount?: UserAccount): UserProxy | undefined => {
    if (!user) {
      return undefined
    }
    const {id, email} = user
    const {avaShortName, hintInfo, preview, avaColorByName} = UserAvatarUtils
    const account = userAccount ?? Accounts.get(id)
    const {realName, status} = account
    const box = Sync.getCurrentSandbox()
    const privelege = box.users.get(id) || {isAdmin: false}

    const userName = realName === '_' ? email || '—' : realName

    return {
      userId: id,
      userImage: preview(account.avatar),
      userInfo: hintInfo(account, email),
      userName,
      userShortName: avaShortName(userName, user),
      userBackgroundColor: avaColorByName(userName, email),
      userStatus: status,
      userIsInDoNotDisturbMode: UserAccount.isInDnd(account),
      userIsAdmin: privelege.isAdmin,
      userEmail: user.email,
      userRole: user.userRole,
      deleted: !box.isUserInCompany(user.id)
    }
  }
}
